export function getPageTitle(title: string, subtitle?: string) {
  return `${title}${
    subtitle ? `: ${subtitle}` : ""
  } | Jordan's Digital Platform`;
}
